<template>
    <div class="typo typo--sm typo--secondary mt-2">
        Dostępna w
        <strong>
            {{ data.subscriptions.filter((el) => el.state === 'available').length }} z
        </strong>
        <span
            v-html="
                $options.filters.plurals(
                    data.subscriptions.length,
                    'sklepu',
                    'sklepów',
                    undefined,
                    true
                )
            "
        />
    </div>
</template>

<script>
export default {
    name: 'AvailablePromoShops',
    props: {
        data: {
            type: Object,
            required: true
        }
    }
}
</script>